module.exports = "<ng-container>\n    <div class=\"tab-container\">\n        <ng-container *ngFor=\"let tab of activeTabs; let i = index\">\n            <a class=\"tab\" [ngClass]=\"{'selected': i === selectedIndex}\" (click)=\"selectTab(i)\">\n                <p [innerHtml]=\"tab.title\"></p>\n            </a>\n        </ng-container>\n    </div>\n    <div class=\"content-outlet\" >\n        <ng-content select=\"tab\"></ng-content>\n    </div>\n</ng-container>"


//////////////////
// WEBPACK FOOTER
// ./src/angular-framework-client-components/components/tabs/tabs-view.template.html
// module id = 850
// module chunks = 2